import { Injectable } from "@angular/core";

@Injectable()
export class ResponseService {
    public formatResponseBody(res) {
        return { data: res.data.result };
    }
}
